import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import EmptyList from '../common/emptyOrderList';
import OrderInfo from './orderInfo';

const SPECIAL_TYPE = 'E';

const isSubstituteCancelled = (order) => {
  return Boolean(
    order.orderType === SPECIAL_TYPE &&
    order.observations &&
    order.observations.includes('Anulado automáticamente (sustituto)')
  );
};

const extractChain = (observations) => {
  if (!observations || !observations.includes('Sustitución:')) {
    return [];
  }
  const match = observations.match(/Sustitución: ([^|]+)/u);
  if (!match) {
    return [];
  }
  return match[1].trim().split(' > ');
};

const groupOrders = (orders) => {
  const cancelledOrders = orders.filter(isSubstituteCancelled);
  const finalOrders = orders.filter((o) => !isSubstituteCancelled(o));

  return finalOrders.map((order) => {
    const chain = extractChain(order.observations);
    if (!chain.length) {
      return Object.assign({}, order, {'substitutedOrders': []});
    }

    const substitutedCodes = chain.slice(0, chain.length - 1);

    const relatedCancelled = substitutedCodes.map((code, index) => {
      const cancelledOrder = cancelledOrders.find((c) => c.partCode === code);
      const substituteCode = chain[index + 1];
      return {
        'partCode': code,
        'substituteCode': substituteCode,
        'original': cancelledOrder || null,
      };
    });

    return Object.assign({}, order, {'substitutedOrders': relatedCancelled});
  });
};

class Detail extends Component {
  renderBody() {
    const {loading, orders} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!orders.length) {
      return (<EmptyList />);
    }

    const grouped = groupOrders(orders);

    return grouped.map((order, index) => {
      return (
        <OrderInfo key={index} order={order} />
      );
    });
  }

  render() {
    return (
      <Card raised fluid className='tracking-detail'>
        <div className='scroll-table-container'>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Pedido</Table.HeaderCell>
                <Table.HeaderCell>Tipo de Pedido</Table.HeaderCell>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Cant. Pedido</Table.HeaderCell>
                <Table.HeaderCell>Cant. Atendida</Table.HeaderCell>
                <Table.HeaderCell>F. Pedido</Table.HeaderCell>
                <Table.HeaderCell>Via concesionario</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
                <Table.HeaderCell>Usuario</Table.HeaderCell>
                <Table.HeaderCell>Referencia</Table.HeaderCell>
                <Table.HeaderCell>ETA Estándar</Table.HeaderCell>
                <Table.HeaderCell>ETA Actualizada</Table.HeaderCell>
                <Table.HeaderCell>OR</Table.HeaderCell>
                <Table.HeaderCell>Facturación</Table.HeaderCell>
                <Table.HeaderCell>Comentarios</Table.HeaderCell>
                <Table.HeaderCell>Observaciones</Table.HeaderCell>
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderBody()}</Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.ordersGroupedManagement.loading,
    'orders': state.ordersGroupedManagement.list,
  };
};

export default connect(mapStateToProps)(Detail);
